<template>
  <v-dialog v-model="dialogLocal" max-width="320">
    <v-card>
      <v-card-title class="justify-center">
        Seleccionar Hora
      </v-card-title>

      <v-card-text class="d-flex justify-center">
        <v-time-picker
          v-model="horaTemp"
          format="24hr"
          full-width
          :ampm="false"
        />
      </v-card-text>

      <v-card-actions class="justify-end">
        <v-btn text @click="dialogLocal = false">Cancelar</v-btn>
        <v-btn color="primary" @click="guardar">Aceptar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'HoraGeneral',
  props: {
    value: String,
    dialog: Boolean
  },

  data () {
    return {
      horaTemp: null
    }
  },

  computed: {
    dialogLocal: {
      get() {
        return this.dialog
      },
      set(val) {
        this.$emit('update:dialog', val)
      }
    }
  },
  methods: {
    guardar () {
      this.$emit('input', this.horaTemp)
      this.dialogLocal = false
    }
  },
  watch: {
    dialog(val) {
      if (val) {
        this.horaTemp = this.value || '00:00'
      }
    }
  }
}
</script>